

























































import Vue, { PropOptions } from 'vue';
import TopBar from '@/components/TopBar.vue';
import DispsetModal from '@/components/DispsetModal.vue';
import * as TypeVariable from '@/parts/VariableInput.vue';
import parts from '@/parts';
import * as PClass from '@/class';
import * as Models from '@/class/models/views';
import mv from './mixins-views';
import InfiniteLoading from 'vue-infinite-loading';

export default Vue.extend({
  name: 'Client',
  mixins: [mv],
  components: {
    ...parts, TopBar, DispsetModal, InfiniteLoading,
  },
  props: {
    myData: Object as PropOptions<Models.ICoordinator>,
    confirmDialog: Function,
    localDatas: Object as PropOptions<Models.ILocalDatas>,
    getDatas: Object as PropOptions<Models.IGetDatas>,
  },
  computed: {
    dispThDatas(): any[] {
      if (this.localData.disp) {
        return this.thDatas.filter((v, n) => (this.localData.disp[n]))
      } else {
        return this.thDatas
      }
    },
    searchDatas(): any[] {

      return this.getDatas.getClientDatas
      .map(((v) => {
        let rankName = '';
        switch (v.rank) {
          case 1:
            rankName = 'A'
            break;
          case 2:
            rankName = 'B'
            break;
          case 3:
            rankName = 'C'
            break;
          case 4:
            rankName = 'D'
            break;
          default:
            rankName = ''
            break;
        }
        return {...v, ...{systemStopFlag: v.systemStopFlag !== 0 ? '異常' : '正常'}, ...{rankName}}
        }))
      .filter((v) => (
        v.clientName.indexOf(this.searchWord) >= 0
        || v.clientMail.indexOf(this.searchWord) >= 0
        || v.deliveryMail.indexOf(this.searchWord) >= 0
        || v.companyName.indexOf(this.searchWord) >= 0
        || v.comment.indexOf(this.searchWord) >= 0
        || v.systemStopFlag.indexOf(this.searchWord) >= 0
      ));
    },
    searchDatasCount(): number {
      return this.searchDatas.length;
    },
    trDatasCount(): number {
      return this.trDatas.length;
    },
  },
  data() {
    return {
      inputData: new Models.CClient(),
      getClientDatas: [] as Models.IClient[],
      searchWord: '',
      items: [
        {key: 'companyName', name: '社名', type: TypeVariable.INPUT_TYPE.TEXT, required: true, error: '', max: 99},
        {key: 'address', name: '住所', type: TypeVariable.INPUT_TYPE.TEXT, required: false, error: '', max: 250, listHide: true},
        {key: 'addressHeadOffice', name: '住所(本店)', type: TypeVariable.INPUT_TYPE.TEXT, required: false, error: '', max: 250, listHide: true },
        {key: 'tel', name: '電話番号', type: TypeVariable.INPUT_TYPE.TEXT, required: false, error: '', max: 20, listHide: true},
        {key: 'url', name: 'URL', type: TypeVariable.INPUT_TYPE.TEXT, required: false, error: '', max: 99},
        {key: 'capital', name: '資本金（万円）', type: TypeVariable.INPUT_TYPE.NUMBER, required: false, error: ''},
        {key: 'employees', name: '社員数', type: TypeVariable.INPUT_TYPE.TEXT, required: false, error: '', max: 99},
        {key: 'clientName', name: '顧客の担当者名', type: TypeVariable.INPUT_TYPE.TEXT, required: true, error: '', max: 99},
        {key: 'clientMail', name: '顧客の担当者メルアド', type: TypeVariable.INPUT_TYPE.TEXT, required: true, error: '', max: 99},
        {key: 'deliveryMail', name: '顧客の配信先メルアド', type: TypeVariable.INPUT_TYPE.TEXT, required: true, error: '', max: 99},
        {key: 'stopDelivery', name: '配信停止', type: TypeVariable.INPUT_TYPE.CHECKBOX, required: false, error: '', class: ''},
        {key: 'engineerDelivery', name: '要員配信', type: TypeVariable.INPUT_TYPE.CHECKBOX, required: false, error: '', class: 'quarter_block'},
        {key: 'annkennDelivery', name: '案件配信', type: TypeVariable.INPUT_TYPE.CHECKBOX, required: false, error: '', class: 'quarter_block'},
        {key: 'comment', name: 'コメント', type: TypeVariable.INPUT_TYPE.TEXTAREA, required: false, error: '', max: 500},
        {key: 'rank', name: 'ランク', type: TypeVariable.INPUT_TYPE.SELECT, required: false, error: '', options: PClass.CONST.ARRAY.CLIENT_RANK, disabled: true},
      ] as TypeVariable.IVariableInput[],
      thDatas: [
        {key: 'companyName', name: '社名', sort: true},
        {key: 'address', name: '住所'},
        {key: 'addressHeadOffice', name: '住所(本店)' },
        {key: 'tel', name: '電話番号'},
        {key: 'url', name: 'URL'},
        {key: 'capital', name: '資本金（万円）', sort: true},
        {key: 'employees', name: '社員数', sort: true},
        {key: 'clientName', name: '顧客の担当者名'},
        {key: 'clientMail', name: '顧客の担当者メルアド'},
        {key: 'deliveryMail', name: '顧客の配信先メルアド'},
        {key: 'stopDelivery', name: '配信停止', sort: true},
        {key: 'engineerDelivery', name: '要員配信', sort: true},
        {key: 'annkennDelivery', name: '案件配信', sort: true},
        {key: 'comment', name: 'コメント'},
        {key: 'createDate', name: '作成日', sort: true},
        {key: 'updateDate', name: '更新日', sort: true},
        {key: 'systemStopFlag', name: '状態', sort: false},
        {key: 'rankName', name: 'ランク', sort: true},
      ] as TypeVariable.IVariableInput[],
      localData: {} as Models.ILocalData,
      listDispModal: false,
      infiniteId: 0,
      trDatas: [] as Models.IClient[],
      searchFlag: 0,
      complateCount: 0,
      errorMessage: '',
    };
  },
  async mounted() {
    this.$emit('loading', this.getDatas.getClientDatas.length <= 0 ? true : false);

    // input調整
    if (this.myData.role === PClass.CONST.ROLE.ADMIN || this.myData.role === 0) {
      const rankItems = this.items.find((v) => v.key === 'rank')
      if (rankItems) {
        rankItems.disabled = false;
      }
    }
    // ローカルデータ初期化
    this.localData = new Models.CLocalData('companyName', this.thDatas)
    // console.log(this.localData.disp);
    // ローカルデータ読み込み
    if (this.localDatas.client) {
      this.localData.target = this.localDatas.client.target;
      this.localData.asc = this.localDatas.client.asc;
      if (this.localDatas.client.disp) {
        if (this.localDatas.client.disp.length === this.localData.disp.length) {
          // console.log(this.localDatas.client.disp)
          this.localData.disp = this.localDatas.client.disp;
        }
      }
      this.setData();
    }
    // データ取得
    await this.fncGASData(true);
    this.$emit('loading', false);
  },
  methods: {
    async fncGASData(firstFlag = false) {
      const api = new PClass.API();
      const res = await api.get<Models.VClient>('client', {firstFlag, target: this.localData.target, asc: this.localData.asc} as Models.ISortData);
      // console.log(res);
      if (!res.result.error) {
        // this.getDatas = res.data;
        this.getDatas.getClientDatas = res.data.clients;
        if (firstFlag) {
          // this.getcoordinatorDatas = res.data.coordinators;
        }
        this.resetData();
      } else {
        // this.$emit('change', NOC.APP.MODE.LOGIN);
      }
    },
    changeMode(mode: string) {
      (this as any).mixChangeMode(mode);
    },
    onClickEditMode(client: Models.IClient) {
      scrollTo(0, 0);
      this.inputData = JSON.parse(JSON.stringify(this.getDatas.getClientDatas.filter((v) => (v.id === client.id))[0]));
      this.changeMode(PClass.CONST.MODE.EDIT)
      if (this.inputData.systemStopFlag === 0) {
        // stopDeliveryItem.disabled = false;
        // engineerDelivery!!.disabled = false;
        // annkennDelivery!!.disabled = false;
        this.errorMessage = '';
      } else {
        // stopDeliveryItem.disabled = true;
        // engineerDelivery!!.disabled = true;
        // annkennDelivery!!.disabled = true;

        let message = '※原因不明でシステムで配信停止中'
        switch (this.inputData.systemStopFlag) {
          case 1:
            message = '※配信不可によりシステムで配信停止中'
            break;
          case 2:
            message = '※迷惑メール扱いによりシステムで配信停止中'
            break;
          case 3:
            message = '※配信失敗によりシステムで配信停止中'
            break;
        }
        this.errorMessage = message;
      }
    },
    onClickNewMode() {
      this.inputData = new Models.CClient();
      this.changeMode(PClass.CONST.MODE.NEW);
    },
    async onClickEdit() {
      this.$emit('loading', true);
      if (TypeVariable.checkValues(this.inputData, this.items) > 0) {
        this.$emit('loading', false);
        return false;
      }
      // console.log(this.inputData);
      const api = new PClass.API();
      const res = await api.post<Models.IClient, Models.VClient>('client/edit', this.inputData);
      // console.log(res);

      if (!res.result.error) {
        this.onClickCancel()
        this.fncGASData();
      } else {
        this.$emit('info', res.result.message);
      }
      this.$emit('loading', false);
    },
    async onClickNew() {
      this.$emit('loading', true);
      if (TypeVariable.checkValues(this.inputData, this.items) > 0) {
        this.$emit('loading', false);
        return false;
      }
      const api = new PClass.API();
      const res = await api.post<Models.IClient, Models.VClient>('client/new', this.inputData);
      // console.log(res);

      if (!res.result.error) {
        this.onClickCancel();
        this.fncGASData();
      } else {
        this.$emit('info', res.result.message);
      }
      this.$emit('loading', false);
    },
    onClickCancel() {
      this.changeMode(PClass.CONST.MODE.NORMAL);
    },
    async onClickTableSort(key: string) {
      this.$emit('loading', true);
      // ローカルデータ更新
      if (this.localData.target === key) {
        this.localData.asc = !this.localData.asc
      } else {
        this.localData.target = key;
        this.localData.asc = false;
      }
      // ※props操作
      this.localDatas.client = this.localData;
      this.$emit('setLocalDatas')
      // データ取得
      await this.fncGASData();
      this.$emit('loading', false);
    },
    onClickDesideListDispModal(list: boolean[]) {
      this.localData.disp = list;
      this.localDatas.client = this.localData;
      this.$emit('setLocalDatas')
      this.listDispModal = false;
    },
    async onClickDelete(deleteData: Models.IClient) {
      if (await this.confirmDialog('このクライアントを削除します。\nよろしいでしょうか？')) {
        this.$emit('loading', true);
        const api = new PClass.API();
        const res = await api.delete<Models.VClient>('client', {id: deleteData.id});
        if (!res.result.error) {
          await this.fncGASData();
        } else {
          this.$emit('info', res.result.message);
        }
        this.$emit('loading', false);
      }
    },
    setData() {
      this.trDatas =  this.trDatas.concat(this.searchDatas.slice(this.trDatasCount, this.trDatasCount + 50))
    },
    resetData() {
      this.trDatas = this.searchDatas.slice(0, 50);
      if ((this.$refs.infiniteLoading0 as any) !== undefined) {
        (this.$refs.infiniteLoading as any).stateChanger.reset();
      }
    },
    async infiniteHandler($state: any) {
      // console.log('infiniteHandler')
      if (this.trDatasCount !== 0) {
        this.setData();
        if (this.searchDatasCount <= this.trDatasCount) {
          // console.log('complate')
          $state.complete();
        } else {
          // console.log('load', this.trDatasCount, this.searchDatasCount)
          $state.loaded();
        }
      } else {
        if (this.complateCount < 3) {
          await new Promise((resolve) => setTimeout(resolve, 3000));
          this.complateCount++
          $state.loaded();
        } else {
          $state.complete();
        }
      }
    },
    async onInputSearch() {
      const date = Date.now();
      // console.log('changeSearchWord',this.searchWord, date)
      this.searchFlag = date
      await new Promise((resolve) => setTimeout(resolve, 800));
      if (this.searchFlag === date) {
        // console.log('search', date);
        this.resetData();
      }
    },
  },
});

